module.exports = __webpack_public_path__ + "img/juri.000922a8.jpeg";